import { render, staticRenderFns } from "./MemberListComponent.vue?vue&type=template&id=520e5320&"
import script from "./MemberListComponent.vue?vue&type=script&lang=js&"
export * from "./MemberListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports